// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-form[data-v-5384cb9b] {\n  margin-top: 60px;\n  border-radius: 0px;\n  background: #feffff;\n  box-shadow: 5px 5px 7px #f1f2f2, -5px -5px 7px #ffffff;\n  width: 80%;\n}\n.consent[data-v-5384cb9b] {\n  color: #e53935;\n}\n@media only screen and (max-width: 959px) {\n.v-form[data-v-5384cb9b] {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
